import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import MP3TagEditor from './components/MP3TagEditor';
import About from './pages/About';          // ← NEW
import Contact from './pages/Contact';
import History from './pages/History';           // ← IMPORTANT
import Footer from './components/Footer';
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import './App.css';

function App() {
  return (
    <ThemeProvider initial="light">
      <LanguageProvider initial="fr">
        <BrowserRouter>
          <div className="min-h-screen bg-white text-gray-900 dark:bg-gray-900 dark:text-gray-100">
            <Header logoSrc="/logo.png" />
            <Routes>
              <Route path="/" element={<Navigate to="/mp3tagedit" replace />} />
              <Route path="/mp3tagedit" element={<MP3TagEditor />} />
              <Route path="/about" element={<About />} />        {/* ← NEW */}
              <Route path="/history" element={<History />} />   {/* ← LA ROUTE */}
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Navigate to="/mp3tagedit" replace />} />
            </Routes>
            <Footer />
          </div>
        </BrowserRouter>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
